import React, { useState } from 'react';
import { EmailFormProps } from '../../types/types';
import Button from '../Button/Button';

const FormEmail: React.FC<EmailFormProps> = ({
  source,
  className,
  buttonText,
  setIsRequestSent,
}) => {
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (email.trim() === '') {
      return;
    }

    setIsRequestSent(true);
    try {
      const emailValid = validateEmail(email);
      setIsValidEmail(emailValid);

      if (!emailValid) {
        console.log('Invalid email');
        return;
      }

      const response = await fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, source }),
      });

      if (response.ok) {
        setEmail('');
        console.log('Email sent successfully!');
      } else {
        console.log('Message sending failed');
      }
    } catch (error) {
      console.log('Request failed', error);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setIsValidEmail(validateEmail(e.target.value));
  };

  const validateEmail = (input: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      <input
        type='email'
        value={email}
        onChange={handleChange}
        placeholder='Type your email'
        className={`form__input ${isValidEmail ? '' : 'error'}`}
      />
      <Button className='form__button' type='submit'>
        {buttonText}
      </Button>
    </form>
  );
};

export default FormEmail;
